export const filter = {
    id: "",
    patient_id: "",
    doctor_id: "",
    service_id: "",
    created_at: "",
    updated_at: "",
};
